
import { Component, ElementRef, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { PageBase, T4SettingsPage, T4SettingsService, ControlType, T4Setting } from 't4core';
import { HttpClient } from '@angular/common/http';

@Component({
  styleUrls: ['./IframeGenerator.css'],
  selector: 'iframe-generator',
  templateUrl: './IframeGenerator.html',
})
export class IframeGeneratorComponent extends PageBase {

   //IFrame
  public iframeText : string = "";
  public externalApiId: string[] = ["KanLeiesUnmanned_API", "24RentalUnmanned_API", "BookSwipeGo_API", "OKQ8Unmanned_API"];
  public selectedApi: string = "";
  public useSubContext: boolean = false;
  public useTheme: boolean = false


  //Webbooking
  public webbookingScriptText: string = "";
  private readonly webScriptTemplate: string = "";

  //Partner Webbooking
  public partnerScriptText: string = "";
  private readonly partnerScriptTemplate: string =
  `
  <div>
  <script language="javascript" src="https://booking.turbo4.net/Scripts/setup/Use4Free.js" id ='Use4FreeImportScript'></script>
  <script language="javascript"> new Use4FreeFacory().buildPartnerPage('$externalKey', '$theme', '$language');</script>
  </div>
  `


  // Settings
  public themes: string[] = [
     "24rental.se"
    ,"AZ"
    ,"Bauhaus"
    ,"BauhausOutdated"
    ,"Bilka"
    ,"BrenderupRental"
    ,"BSG"
    ,"Byggmax"
    ,"Circlek"
    ,"Cramo"
    ,"Erikshjalpen"
    ,"Esso"
    ,"Fotex"
    ,"Hagebau"
    ,"HaraldNyborg"
    ,"Henriksson"
    ,"Hornbach"
    ,"Ikea"
    ,"Jysk"
    ,"K-Bygg"
    ,"Maxbo"
    ,"OKQ8.se"
    ,"OneWay"
    ,"Plantagen"
    ,"Preem"
    ,"Shell"
    ,"Tysse Utleie"
    ,"Use4Free"
    ,"XXXLutz"
  ]
  public languages: string[] = ["en", "sv", "da", "de", "no"]
  public selectedTheme: string;
  public selectedlanguage: string = "en";
  public externalID: string = this.Settings.clientSettings.ContextId;
  public privateKey: string = "";

  constructor(el: ElementRef, private svcSettings: T4SettingsService, private clipboard: Clipboard, private http: HttpClient) {
    super(el, "IframeSettings");

  }

  async ngOnInit() {
    this.generateSettings();
  }


  public async generateSettings() {

 
     this.privateKey = await this.svcSettings.GetPrivateKey(); // New function, or should we update ClientSettings so it should also hold the PrivateKey?


    var subcontext = "";
    var theme = "";

    if (this.useSubContext) subcontext = this.Settings.clientSettings.ContextId;
    if (this.useTheme)  theme = "";
    

    var uri = await this.Api.get<string>("Settings/GetIframeUrl");


    if (uri != "Authentication Error") {
      this.iframeText =
        `<!-- Code that must be inserted exactely as is-->
      <iframe id = "t4.app.intellitrailer" style = "width: 100%; height: 868px; border: 0px; display: block;" src="${uri}" allow="geolocation https://booking.turbo4.net"></iframe>  
      <script language = "javascript">  
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";  
	      var eventer = window[eventMethod];
        var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
        eventer(messageEvent, function (e) { document.getElementById('t4.app.intellitrailer').style.height = e.data + 'px'; });
      </script>  
    < !--End code-- >

    <script language="javascript"> 
      var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
      var eventer = window[eventMethod]; var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
      eventer(messageEvent, function (e) { document.getElementById('t4.app.intellitrailer').style.height = e.data + 'px'; });
      function t4Resize() { var frame = document.getElementById("t4.app.intellitrailer");
      var userAgent = navigator.userAgent || navigator.vendor || window.opera; frame.style.display = 'block';
      if (frame.clientWidth <= 768) { frame.style.display = 'block'; }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream && frame.clientWidth <= 768) { frame.style.display = 'block'; } } t4Resize();
      window.addEventListener("resize", function() { t4Resize(); });
    </script>
    `;
    }
    else this.iframeText = uri;


    this.updatePartnerScript();
    this.updateWebScript();
  }

  public updatePartnerScript() {
    this.partnerScriptText = this.partnerScriptTemplate
    ['split']('$externalKey')['join'](this.externalID)
    ['split']('$theme')['join'](this.selectedTheme)
    ['split']('$language')['join'](this.selectedlanguage);
  }

  public updateWebScript() {
    this.webbookingScriptText = this.webScriptTemplate
    ['split']('$externalKey')['join'](this.externalID)
    ['split']('$theme')['join'](this.selectedTheme)
    ['split']('$language')['join'](this.selectedlanguage);
  }




  public copyToClipboard(text: string) {
    this.clipboard.copy(text);
  }

  public async popupKeysInfo() {
    await this.UI.alertBox({
      headline: "Turbo.IframeGenerator.headExternalPrivateKe",
      headlineDefault: "Information - Keys",
      message:
        `<b>ExternalId</b>: ${this.externalID} <br>
         <b>PrivateId</b>: ${this.privateKey} <br> `
    });
  }

 }



